import Swiper, { Scrollbar, Mousewheel } from "swiper";
class AnnaversumGrid extends HTMLElement {
  constructor() {
    super();

    this.slider = this.querySelector(".annaversum-slider");

    const AnnaversumSlider = new Swiper(this.slider, {
      modules: [Scrollbar, Mousewheel],
      spaceBetween: 12,
      slidesPerView: "auto",
      slidesOffsetBefore: 20,
      slidesOffsetAfter: 20,
      autoHeight: false,
      mousewheel: {
        forceToAxis: true,
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
      },
    });
  }
}

customElements.define("annaversum-grid", AnnaversumGrid);
